<script>
  // Standardized filter/search/tabs row. Replaces the three different ad-hoc filter
  // rows across pages (differing mb-*/gap-*/label idioms). Compose it with
  // SearchInput, FilterTabs, and select/checkbox controls via snippets.
  //
  //   <FilterBar>
  //     {#snippet start()}<SearchInput placeholder="Search users…" />{/snippet}
  //     {#snippet end()}<FilterTabs {tabs} />{/snippet}
  //   </FilterBar>
  //
  // `start` sits left (search/filters), `end` sits right (tabs/view options).
  let { start, end } = $props()
</script>

<div class="flex items-end justify-between gap-4 flex-wrap mb-4">
  {#if start}<div class="flex items-end gap-3 flex-wrap">{@render start()}</div>{/if}
  {#if end}<div class="flex items-center gap-2 flex-wrap ml-auto">{@render end()}</div>{/if}
</div>
